export default __webpack_public_path__ + "static/media/roller2.c7c544ed.gif";